import { getCurrentProductKey, getLocaleFromApplication, getMarketId, getSaleKey } from 'store/selectors'
import { callPlanet } from './'

export const postProductVisit = state => (
  callPlanet('Product/Visit', {
    eventKey: getSaleKey(state),
    locale: getLocaleFromApplication(state),
    marketId: getMarketId(state),
    productKey: getCurrentProductKey(state)
  })
)
